var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 372,
    viewBox: "0 0 419 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.006 91.4431C302.253 127.378 271.3 154.972 238.129 171.568C204.959 188.163 170.689 193.201 138.622 186.195C106.555 179.189 77.7699 160.376 55.0416 131.568C32.3134 102.76 16.4072 64.9279 8.85572 21.7172L200.632 -83.4368L328.006 91.4431Z",
    fill: "#6B40C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_123",
    x: -241.144,
    y: -333.437,
    width: 819.15,
    height: 772.701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_1_123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowBoards);
export default __webpack_public_path__ + "static/media/shadowBoards.08e42ec6225429fcab36b8d65d491ae4.svg";
export { ForwardRef as ReactComponent };